import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableRowProps,
  Theme,
  styled,
} from '@material-ui/core';

import { getDocSelected, getSalesDocs } from 'reducers/returnProducts';
import { setDocSelected } from 'actions/returnProducts';
import { PluginComponent } from 'plugins';

const documentTypes = [
  'ORDER',
  'PREPAYMENT',
  'CREDITINVOICE',
  'QUOTE',
  'OFFER',
  'WAYBILL',
] as const;

const StyledTableRow = styled(TableRow)<
  Theme,
  TableRowProps & { disabled: boolean }
>(({ disabled }) => ({
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.4 : 1,
}));

const DocumentSelection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('return');

  const salesDocs = useSelector(getSalesDocs);
  const docSelected = useSelector(getDocSelected);

  const beautifyType = type =>
    t('documentTypes.documentType', { context: type });

  return (
    <PluginComponent
      hookname="UISalesDocumentSelection"
      props={{ salesDocs, docSelected, beautifyType }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('headers.number')}</TableCell>
            <TableCell>{t('headers.customer')}</TableCell>
            <TableCell>{t('headers.type')}</TableCell>
            <TableCell>{t('headers.date')}</TableCell>
            <TableCell>{t('headers.sum')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {salesDocs.map(document => {
            const typeSupportsStandardReturn = !documentTypes.includes(
              document?.type,
            );
            return (
              <StyledTableRow
                hover
                disabled={!typeSupportsStandardReturn}
                selected={docSelected === document.id}
                key={document.id}
                data-testid="document-row"
                data-test-key={document.id}
                onClick={() => {
                  if (!typeSupportsStandardReturn) return;
                  dispatch(setDocSelected(document.id));
                }}
              >
                <TableCell
                  data-testid="document-number"
                  data-test-key={document.number}
                >
                  {document.number}
                </TableCell>
                <TableCell
                  data-testid="client-name"
                  data-test-key={document.clientName}
                >
                  {document.clientName}
                </TableCell>
                <TableCell
                  data-testid="document-type"
                  data-test-key={document.type}
                >
                  {beautifyType(document.type)}
                </TableCell>
                <TableCell
                  data-testid="document-date"
                  data-test-key={document.date}
                >
                  {document.date}
                </TableCell>
                <TableCell
                  data-testid="document-total"
                  data-test-key={document.total}
                >
                  {parseFloat(document.total).toFixed(2)}
                </TableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </PluginComponent>
  );
};

export default DocumentSelection;
